export default __webpack_public_path__ + "static/media/medal.81c9eaa7.png";